import { render, staticRenderFns } from "./ReferralCategory.vue?vue&type=template&id=134de87b"
import script from "./ReferralCategory.vue?vue&type=script&lang=js"
export * from "./ReferralCategory.vue?vue&type=script&lang=js"
import style0 from "./ReferralCategory.vue?vue&type=style&index=0&id=134de87b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports